import * as React from 'react';

import type { PartnerData } from 'bundles/browse-common/utils/experimentUtils';

type PartnerListContextType = {
  partners?: PartnerData[];
  loading: boolean;
};

const PartnerListContext = React.createContext<PartnerListContextType | undefined>(undefined);

export const usePartnerList = () => {
  return React.useContext(PartnerListContext);
};

export default PartnerListContext;
